import { Box } from '@material-ui/core';
import { useSelector } from 'dva';
// import TooltipMl from './Tooltip';
import SvgIconML from '@/components/SvgIconML/SvgIconML';

export default () => {
  const { trackingUserDetail } = useSelector((state) => state.userBehavior);

  const { userName, userid, bookPageNum, signNum, visitTime } =
    trackingUserDetail || {};
  console.log('trackingLogList', trackingUserDetail);
  return (
    <Box>
      <Box display="flex" mb={2.5}>
        用户属性
        {/* <TooltipMl info="这里是一段文字描述" /> */}
      </Box>
      <Box display="flex" gap="24px" pl={2} pr={2} mb={3}>
        <Box
          width="56px"
          flexShrink="0"
          style={{
            borderRadius: '50%',
            height: '56px',
            backgroundColor: 'rgba(244, 244, 244)',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
          }}
        >
          <SvgIconML
            name="userAvatar"
            size={32}
            style={{ width: '32px', height: '32px' }}
          />
        </Box>
        <Box width="100%" flexShrink="1">
          <Box
            sx={{ color: '#333', marginBottom: '14px' }}
            display="flex"
            justifyContent="space-between"
          >
            <span>用户名称</span>
            <span>{userName}</span>
          </Box>
          <Box
            sx={{ color: '#333' }}
            display="flex"
            justifyContent="space-between"
          >
            <span>用户ID</span>
            <span>{userid}</span>
          </Box>
        </Box>
      </Box>
      <Box display="flex" gap="24px" pl={2} pr={2}>
        <Box width="20px" height="20px" flexShrink="0">
          <SvgIconML
            name="loginNum"
            size={20}
            // fill={theme.palette.primary.main}
            fill={'#1B60AD'}
            className="preview"
          />
        </Box>
        <Box width="100%" flexShrink="1">
          <Box
            sx={{ color: '#333', marginBottom: '14px' }}
            display="flex"
            justifyContent="space-between"
          >
            <span>近30天登陆次数</span>
            <span>{signNum}</span>
          </Box>
        </Box>
      </Box>
      <Box display="flex" gap="24px" pl={2} pr={2}>
        <Box width="20px" height="20px" flexShrink="0">
          <SvgIconML
            name="pageVisityNum"
            size={20}
            // fill={theme.palette.primary.main}
            fill={'#1B60AD'}
            className="preview"
          />
        </Box>
        <Box width="100%" flexShrink="1">
          <Box
            sx={{ color: '#333', marginBottom: '14px' }}
            display="flex"
            justifyContent="space-between"
          >
            <span>近30天页面访问数</span>
            <span>{bookPageNum}</span>
          </Box>
        </Box>
      </Box>
      <Box display="flex" gap="24px" pl={2} pr={2}>
        <Box flexShrink="0">
          <SvgIconML
            name="clock"
            size={20}
            // fill={theme.palette.primary.main}
            fill={'#1B60AD'}
            className="preview"
          />
        </Box>
        <Box width="100%" flexShrink="1">
          <Box
            sx={{ color: '#333' }}
            display="flex"
            justifyContent="space-between"
          >
            <span>最近一次访问时间</span>
            <span>{visitTime}</span>
          </Box>
        </Box>
      </Box>
    </Box>
  );
};
